export default __webpack_public_path__ + "static/media/Business-developmentCr.a34b455d.png";